import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationStratalotTodoApiService } from './organization-stratalot-todo-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationStratalotTodoApiService extends GeneratedOrganizationStratalotTodoApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
